module.exports = __webpack_public_path__ + "static/img/alld.8356a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/alld.png
// module id = Po7Y
// module chunks = 79